import React, { useCallback, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
    position: relative;
    /** Il padding top permette di riservare lo spazio necessario per l'iframe.
        Il valore sarà come l'altezza del contenuto scalata per il fattore scale. */
    padding-top: ${(props) => `${props.scale * props.frameHeight}px`};

    & iframe {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        /** Simuliamo una viewport larga 1000px */
        width: 1000px;
        height: ${(props) => `${props.frameHeight}px`};
        transform-origin: 0 0;
        /** Scaliamo il contenuto in modo da fittare la larghezza massima del contenitore */
        transform: ${(props) => `scale(${props.scale})`};
        border: none;
    }
`;

const AnimationContainer = ({ src, title }) => {
    const iframeRef = useRef();
    const [scale, setScale] = useState(1);
    const [frameHeight, setFrameHeight] = useState(250);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onCreateCallback = useCallback((node) => {
        if (node) {
            /** Viene calcolato di quanto devev scalare l'iframe (che occupa una viewport simulata di
             * 1000px in larghezza) per occupare il 100% del contenitore.
             */
            const scale = node.getBoundingClientRect().width / 1000;
            setScale(scale);
        }
    });

    /**
     * Osserva i cambiamenti che avvengono all'inderno del DOM che mostra l'iframe.
     * Ad ogni cambiamenti viene aggiornata l'altezza del contenitore, aggiungendo un
     * offset di 20px.
     * @param {*} body
     */
    const startObserve = (body) => {
        const observerOptions = {
            childList: true,
            attributes: true,
            subtree: true,
        };
        const callback = (mutations) => {
            mutations.forEach(() => {
                setFrameHeight(iframeRef.current.contentWindow.document.body.scrollHeight + 20);
            });
        };
        const observer = new MutationObserver(callback);
        observer.observe(body, observerOptions);
    };

    return (
        <Container ref={onCreateCallback} scale={scale} frameHeight={frameHeight}>
            <iframe
                ref={iframeRef}
                src={src}
                title={title}
                onLoad={(e) => {
                    startObserve(e.currentTarget.contentWindow.document.body);
                }}
            />
        </Container>
    );
};

AnimationContainer.propTypes = {
    src: PropTypes.string,
    title: PropTypes.string,
};

export default AnimationContainer;
